var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gradient-background",class:_vm.vueAppClasses,attrs:{"id":"app"}},[_c('navbar',{staticClass:"white-background"}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }